<template>
  <div class="modal-card">
    <section class="modal-card-body is-titleless">
      <table class="table is-striped is-narrow is-fullwidth">
        <tbody>
        <tr>
          <th>Navigation</th>
          <th><small class="has-text-weight-normal">Hotkey</small></th>
          <th><small class="has-text-weight-normal">Alternative</small></th>
        </tr>
        <tr>
          <td>Move up a tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <b-tag class="is-warning">
              <b-icon icon="arrow-up" type="is-black"></b-icon>
            </b-tag>
          </td>
          <td>
            <span class="tag is-warning mr-1">SHIFT</span>
            <span class="tag is-warning mr-1">TAB</span>
          </td>
        </tr>
        <tr>
          <td>Move down a tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <b-tag class="is-warning">
              <b-icon icon="arrow-down" type="is-black"></b-icon>
            </b-tag>
          </td>
          <td>
            <span class="tag is-warning mr-1">TAB</span>
          </td>
        </tr>
        <tr>
          <td>Move to specific tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">1</span>/<span class="tag is-warning mr-1">9</span>
          </td>
        </tr>
        <tr>
          <td>Move to first tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">HOME</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Move to last tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">END</span>
          </td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">0</span>
          </td>
        </tr>
        <tr>
          <td>Move to first error</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">R</span>
          </td>
        </tr>
        </tbody>
      </table>

      <table class="table is-striped is-narrow is-fullwidth">
        <tbody>
        <tr>
          <th colspan="3">Adding/Deleting Tweets</th>
        </tr>
        <tr>
          <td>Insert blank tweet below</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">ENTER</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Break at caret and move text into inserted tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">I</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Flow text after caret into tweet below</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">F</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Delete current tweet</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">DEL</span>
          </td>
        <tr>
          <td>Add new thread</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">ALT</span>
            <span class="tag is-warning mr-1">T</span>
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>

      <table class="table is-striped is-narrow is-fullwidth">
        <tbody>
        <tr>
          <th colspan="3">Miscellaneous</th>
        </tr>
        <tr>
          <td>Post thread to Twitter</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">SHIFT</span>
            <span class="tag is-warning mr-1">ENTER</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Schedule thread</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">SHIFT</span>
            <span class="tag is-warning mr-1">S</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Show emojis popup</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">E</span>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Show this hotkeys help</td>
          <td>
            <span class="tag is-warning mr-1" v-html="$modifierKey"></span>
            <span class="tag is-warning mr-1">H</span>
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary" @click="$parent.close()">Got it!</button>
    </footer>
  </div>

</template>

<script>
export default {
  name: "HotkeysModal"
}
</script>

<style scoped>

</style>
